import React from "react";
import { Tabs } from 'antd';
import QualityChemicalTankList from "../chemical/QualityChemicalTankList";
import QualityChemicalStockList from "./QualityChemicalStockList";
import QualityChemicalConfigList from "./QualityChemicalConfigList";
import QualityChemicalMeterList from "./QualityChemicalMeterList";
import { useUserContext } from "../../hooks/UserSettingProvider";
import * as _ from "lodash";

export default function QualityChemicalView() {
  const { features } = useUserContext();

  const items = [
    {
      key: 'stock',
      label: 'สต๊อกสารเคมีคุณภาพ',
      children: <QualityChemicalStockList />,
      hidden : _.get(features, 'lab_input_stock_feature', false) == true ? false : true
    },
    {
      key: 'setting',
      label: 'ตั้งค่าชื่อสารเคมีคุณภาพ',
      children: <QualityChemicalConfigList />,
      hidden : false
    },
    {
      key: 'tank',
      label: 'แทงก์สารเคมีคุณภาพ',
      children: <QualityChemicalTankList />,
      hidden : _.get(features, 'lab_input_stock_feature', false) == true ? false : true
    },
    {
      key: 'meter',
      label: 'มิเตอร์',
      children: <QualityChemicalMeterList/>,
      hidden : _.get(features, 'lab_input_stock_feature', false) == true ? false : true
    },
  ];

  return (
    <div>
      <Tabs 
        defaultActiveKey="quality" 
        destroyInactiveTabPane
        items={items.filter((item) => item.hidden == false)}
        style={{ marginTop : 15}}
      />

    </div>
  )
}